
/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { Fragment } from 'react'

export default function AppliedStudentPreview({
    appliedStudentsList,
}) {

    const sortedStudentsList = Array.isArray(appliedStudentsList)
        ? [...appliedStudentsList].sort((a, b) => a.student_name.localeCompare(b.student_name))
        : [];

    return (
        <div className='overflow-auto scroll-bar min-h-minheight1 max-h-maxheight1 px-[40px] mt-4 '>
            <div className='mb-2  w-[75%] mx-auto'>

                <table className="w-full table-auto greyHeader" id="admin-table">
                    <thead className='top-0 left-0 bg-white'>
                        <tr className='student-th'>
                            <th className="w-[25%]"><span className="flex items-center justify-start font-semibold pl-2">Student Name</span></th>
                            <th className="w-[15%]"><span className="flex items-center justify-start font-semibold text-[#031624]">RET/SSh Ref #</span></th>
                            <th className="w-[17%]"><span className="flex justify-end font-semibold text-[#031624]">Applied Amount</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(sortedStudentsList) && sortedStudentsList.map((student, index) => (
                            <Fragment key={student.student_uuid}>
                                <tr>
                                    <td>
                                        <div className='flex items-center '>
                                            <p className='justify-start flex'>{student.student_name} [{student.student_id}]</p>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="justify-start flex text-[#106eb4] cursor-pointer" onClick={() => handleReceiptClick(student?.scheme_receipt_id)}>{student.reference}</span>
                                    </td>
                                    <td>
                                        <span className="justify-end flex">{parseFloat(student.applied_amount).toFixed(2)}</span>
                                    </td>
                                </tr>
                            </Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}